import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import moleculeObjectReducer from '@f/components/shared/compound-editor/utils/molecule-object/molecule-object.reducer';
import moleculeUtilReducer from '@f/components/shared/compound-editor/utils/molecule-util/molecule-util.reducer';

import AuthenticationReducer from './authentication/authentication.reducer';
import NotificationReducer from './notification/notification.reducer';
import AdministrationReducer from './administration/administration.reducer';
import UserReducer from './user/user.reducer';
import ReactionSearchPreferenceReducer from './reaction-search-preference/reaction-search-preference.reducer';
import ApiTokenReducer from './api-token/api-token.reducer';
import BatchSearchReducer from './batch-search/batch-search.reducer';
import ReportReducer from './report/report.reducer';
import StartingMaterialReducer from './starting-material/starting-material.reducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    authentication: AuthenticationReducer,
    notification: NotificationReducer,
    administration: AdministrationReducer,
    user: UserReducer,
    reactionSearchPreference: ReactionSearchPreferenceReducer,
    moleculeObject: moleculeObjectReducer,
    moleculeUtil: moleculeUtilReducer,
    apiToken: ApiTokenReducer,
    batchSearch: BatchSearchReducer,
    report: ReportReducer,
    startingMaterial: StartingMaterialReducer,
  });
